<div class="offer-info">
  <!-- Primeira coluna -->
  <div class="offer-left-column">
    <!-- Informações do carro -->
    <div class="car-info-section">
      <h2 class="car-title">{{ carTitle }}</h2>

      <div class="info-grid">
        <app-info-field [data]="infoFieldData" [columns]="3">
        </app-info-field>
      </div>
    </div>

    <!-- Foto do carro -->
    <div *ngIf="hasCarImage" class="car-image-section">
      <img [src]="carImage" [alt]="carTitle" class="car-image">
    </div>
  </div>

  <!-- Divider vertical -->
  <div class="vertical-divider"></div>

  <!-- Segunda coluna -->
  <div class="offer-right-column">
    <!-- Título Gere uma oferta COM IMAGEM -->
    <div class="offer-header">
      <h2 class="offer-title">Gere uma oferta</h2>
      <img src="assets/images/maiaImage.png" alt="Maia" class="header-avatar">
    </div>

    <!-- Botões de opção -->
    <div class="option-buttons">
      <button *ngFor="let option of options" class="option-button" [class.active]="selectedOption === option.id"
        (click)="selectOption(option.id)">
        {{ option.label }}
      </button>
    </div>

    <!-- Caixa de texto fixa -->
    <div class="text-box">
      <h3 class="text-box-title">Nova Oferta</h3>

      <!-- Loading state -->
      <div *ngIf="isLoadingText" class="text-loading">
        <div class="loading-spinner"></div>
        <p>Gerando texto da oferta...</p>
      </div>

      <!-- Texto da oferta -->
      <!-- Texto da oferta -->
      <div *ngIf="!isLoadingText && currentOfferText" class="text-box-content">
        <div class="offer-text-wrapper">
          <div style="white-space: pre-wrap;">{{ currentOfferText }}</div>
          <button class="copy-button" (click)="copyToClipboard()" title="Copiar texto">
            <svg class="copy-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
            <span class="copy-text">Copiar</span>
          </button>
        </div>
      </div>

      <!-- Estado vazio -->
      <div *ngIf="!isLoadingText && !currentOfferText" class="text-empty">
        <p>Selecione um tom para gerar a oferta</p>
      </div>
    </div>

    <!-- Botões de ação + Copyright -->
    <div class="action-section">
      <div class="action-buttons">
        <button class="action-button email-button" (click)="sendEmail()"
          [disabled]="isLoadingText || !currentOfferText">
          Enviar via email
        </button>
        <button class="action-button whatsapp-button" (click)="sendWhatsApp()"
          [disabled]="isLoadingText || !currentOfferText">
          Enviar via whatsapp
        </button>
      </div>

      <!-- BOTÃO ALTERAR STATUS ADICIONADO AQUI -->
      <div class="status-button-container">
        <button class="action-button status-button" (click)="openChangeStatusModal()">
          Alterar status
        </button>
      </div>

      <p class="copyright-text">
        © Copyright Volkswagen FS 2025. Texto gerado pela MaIA, inteligência artificial da Volkswagen Financial
        Services.
      </p>
    </div>
  </div>
</div>
